import { Form } from "@/components/core/forms/form.tsx";
import { useModal } from "@/components/core/modals/use-modal";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { useCaseEventsEditMutation, usecaseEventsDeleteMutation } from "@/features/dashboard/api/queries/event-queries.ts";
import userService from "@/features/dashboard/api/services/user-service";
import { formatDate } from "@/utils/format-date";
import { IconCheck, IconDeviceFloppy, IconPencil, IconTrash } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import CaseEventsDeleteModal from "./case-events-delete-modal";

export default function CaseEventsModalEdit({ eventsData }: { eventsData: string }) {
	const modal = useModal();
	const { closeModal } = useModalControl();
	const [error, setError] = useState(null);

	const form = useForm({
		defaultValues: {},
	});

	// const caseEventsDeleteMutation = usecaseEventsDeleteMutation(eventsData?.extendedProps.event_id);
	const caseEventsEditMutation = useCaseEventsEditMutation(eventsData?.extendedProps.event_id);
	const [title, setTitle] = useState(eventsData?.title || "");
	const [date, setDate] = useState(eventsData?.extendedProps?.start_at || "");
	const [endDate, setEndDate] = useState(eventsData?.extendedProps?.end_at || "");

	return (
		<Form {...form}>
			<form className="w-full">
				<div className="flex flex-col w-full rounded-md border border-border/50">
					<table className="text-sm">
						<thead>
							<tr className="border-b-2 border-border/50">
								<th className="w-[220px] text-left text-foreground-dark p-3">Event Title</th>
								<th className="text-left text-foreground-dark p-3">Date From</th>
								<th className="text-left text-foreground-dark p-3">Date To</th>
								<th className="text-left text-foreground-dark p-3">Action</th>
							</tr>
						</thead>
						<tbody>
							<tr className="border-b border-border/50 last:border-b-0">
								<td className="px-3 py-2">
									<input
										type="text"
										value={title}
										onChange={(e) => {
											setTitle(e.target.value);
											onChange?.({ ...eventsData, title: e.target.value, start_at: date });
										}}
										className="w-full rounded border px-2 py-1 text-sm"
									/>
								</td>

								<td className="px-3 py-2">
									<input
										type="datetime-local"
										value={date ? date.slice(0, 16) : ""}
										onChange={(e) => {
											setDate(e.target.value);
											onChange?.({ ...eventsData, title, start_at: e.target.value });
										}}
										className="w-full rounded border px-2 py-1 text-sm"
									/>
								</td>

								<td className="px-3 py-2">
									<input
										type="datetime-local"
										value={endDate ? endDate.slice(0, 16) : ""}
										onChange={(e) => {
											setEndDate(e.target.value);
											onChange?.({ ...eventsData, title, end_at: e.target.value });
										}}
										className="w-full rounded border px-2 py-1 text-sm"
									/>
								</td>

								<td className="px-3 py-2">
									<div className="flex items-center gap-2">
										<button
											type="button"
											className="p-1 rounded hover:bg-accent"
											onClick={() => {
												const modalId = modal.openModal({
													allowClose: true,
													title: "Update Event Details",
													size: "md",
													showHeader: true,
													showFooter: false,
													component: (
														<CaseEventsDeleteModal
															data={eventsData}
															edit={true}
															handleSubmit={async (values) => {
																const response = await userService.validatePassword(values.password);
																if (response.message === "Valid") {
																	setError(null);
																	sessionStorage.setItem("password_entered_at", moment());
																	await caseEventsEditMutation.mutateAsync({
																		id: eventsData?.extendedProps.event_id,
																		title,
																		start_at: date,
																		end_at: endDate,
																	});
																	closeModal();
																	modal.closeModal(modalId);
																} else {
																	setError(response.message);
																	toast.error("Invalid password. Please try again.");
																}
															}}
														/>
													),
												});
											}}
										>
											<IconDeviceFloppy size={20} className="text-blue-600" />
										</button>
										{/* <button
											type="button"
											className="p-1 rounded hover:bg-accent"
											onClick={() => {
												const modalId = modal.openModal({
													allowClose: true,
													title: "Delete Events Activity",
													size: "md",
													showHeader: true,
													showFooter: false,
													component: (
														<CaseEventsDeleteModal
															data={eventsData}
															handleSubmit={async (values) => {
																const response = await userService.validatePassword(values.password);
																if (response.message === "Valid") {
																	setError(null);
																	sessionStorage.setItem("password_entered_at", moment());
																	await caseEventsDeleteMutation.mutateAsync(eventsData?.extendedProps.event_id);
																	closeModal();
																	modal.closeModal(modalId);
																} else {
																	setError(response.message);
																	toast.error("Invalid password. Please try again.");
																}
															}}
														/>
													),
												});
											}}
										>
											<IconTrash size={16} className="text-red-600" />
										</button> */}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</form>
		</Form>
	);
}
